import React, {Fragment} from 'react';
import i18n from 'i18next';
import Guest from '@/Layouts/Guest';
import {FormInput, PhoneOrEmailInput} from "@/Components/Controls";
import {Head, Link, usePage} from '@inertiajs/inertia-react';
import SetPasswordForm from "@/Pages/Auth/SetPasswordForm";
import ProductLogo from "@/Components/ProductLogo";
import usePasswordStateManager from "@/Hooks/usePasswordStateManager";
import {ApplicationViewType} from "@/Enums/ApplicationViewType";

export default function ResetPassword({ token, email_or_phone }) {
    const {data, validationState, onChange, onEmailPhoneTokenChange,
        post, processing, errors} =
        usePasswordStateManager(ApplicationViewType.AUTH, {'email_or_phone':email_or_phone, 'token': token});

    const loginMethod = usePage().props.login_method ?? 'email';

    const submit = (e) => {
        e.preventDefault();
        if(validationState.passwordIsValid)
        {
            post(route('password.update'));
        }
        e.preventDefault();
    };

    return (
        <Guest classes="d-flex align-items-center justify-content-center vh-100">
            <Head title="Reset Password" />
            <div className="reset-password">
                <form onSubmit={submit}>
                    <ProductLogo />
                    <Fragment>
                        {usePage().props.token &&
                            <div className="instructions">{i18n.t("reset-password.reset-password")}</div>
                        }
                        {!usePage().props.token &&
                            <Fragment>
                                <div className="instructions">{i18n.t(`reset-password.${loginMethod}.reset-password-with-token`)}</div>
                                <FormInput
                                    error={errors["token"]}
                                    name="token"
                                    isFocused={true}
                                    value={data.token}
                                    onChange={onEmailPhoneTokenChange}
                                    label={i18n.t(`reset-password.${loginMethod}.token`)}
                                    className="col-12"
                                    dataQa="reset-password-token"
                                />
                            </Fragment>
                        }
                        <div className="row">
                            <PhoneOrEmailInput
                                    error={errors["email_or_phone"]}
                                    name="email_or_phone"
                                    isFocused={ usePage().props.token }
                                    value={data.email_or_phone}
                                    onChange={onEmailPhoneTokenChange}
                                    label={i18n.t("forgot-password.email-or-phone")}
                                    className="col-12"
                                    dataQa="reset-password-email"
                            />
                        </div>
                        <SetPasswordForm errors={errors} data={data} state={validationState} onChange={onChange} />
                        <button
                            type="submit"
                            className="w-100 btn btn-primary"
                            disabled={!validationState.passwordIsValid || processing}
                        >
                            {i18n.t("set-password.done")}
                        </button>
                        {!usePage().props.token &&
                            <Link href={route('password.request')} className="link">
                                {i18n.t("forgot-password.try-another-way")}
                            </Link>
                        }
                    </Fragment>
                </form>
            </div>
        </Guest>
    );
}
